import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Children } from "react";
import { nullFunction } from "../../../../../../helpers/null.js";
import TabButtonView from "../../components/TabButtonView/index.js";
import AccordionMobile from "../../components/accordionMobile/index.js";
import useTabs from "../../hooks/useTabs.js";
import * as SS from "../../styled.js";
import * as S from "./styled.js";
export const TabsMobileView = ({ className ='tabs-component' , tabs =[] , selectedTab: propsSelectedTab = 0 , onClick =nullFunction , orientation ='horizontal' , color ='default' , showOnlyOneTab =true , preRenderTabs =false , ...rest })=>{
    const { selectedTab , visibleTabs  } = useTabs(tabs, propsSelectedTab);
    const showTabs = showOnlyOneTab ? true : tabs.length > 1;
    if (orientation == 'horizontal') {
        return /*#__PURE__*/ _jsxs(S.TabsStyled, {
            className: classNames({
                [className]: !!className,
                vertical: true
            }),
            color: color,
            ...rest,
            "data-testid": "Tabs",
            children: [
                showTabs && /*#__PURE__*/ _jsx(SS.TabsCarouselList, {
                    role: "tablist",
                    children: Children.toArray(tabs.map((tab)=>/*#__PURE__*/ _jsx(SS.TabsCarouselItem, {
                            role: "none",
                            children: /*#__PURE__*/ _jsx(TabButtonView, {
                                tab: tab,
                                className: className,
                                selectedTab: selectedTab,
                                disabled: selectedTab === tab.index,
                                onClick: !tab.data?.isLink ? onClick : nullFunction
                            })
                        })))
                }),
                /*#__PURE__*/ _jsx(SS.TabsWrapper, {
                    role: "tabpanel",
                    "aria-labelledby": `btn-${selectedTab}`,
                    id: `tabpanel-${selectedTab}`,
                    children: Children.toArray((preRenderTabs ? tabs : visibleTabs.map((visibleTab)=>tabs[visibleTab])).map((tab)=>/*#__PURE__*/ _jsx(SS.TabsContent, {
                            className: classNames({
                                'is-active': selectedTab === tab.index
                            }),
                            children: tab.element
                        })))
                })
            ]
        });
    }
    if (orientation == 'vertical') {
        return /*#__PURE__*/ _jsx(AccordionMobile, {
            "data-testid": "Accordion",
            tabs: tabs
        });
    }
    return null;
};
export default TabsMobileView;

//# sourceMappingURL=index.js.map